import {
  Flex,
  Box,
  Heading,
  Spinner,
  useColorModeValue,
} from "@chakra-ui/react";

// Components
import Item from "./Item";
import Disclaimer from "components/Disclaimer";
import { Subtitle, HeadPage } from "ui";

// hooks
import useHashConnect from "hooks/useHashConnect";

// Constants
import { getDefiData, getItemGroups } from "constants/defi";
import { DefiDataValues } from "types/DefiData";

// Images
import hbarxDarkIcon from "assets/hbarxDark.svg";
import hbarxLightIcon from "assets/hbarxLight.svg";
import hbarDarkIcon from "assets/hederaDark.svg";
import hbarLightIcon from "assets/hederaLight.svg";

// third party
import _isEmpty from "lodash/isEmpty";

const DeFi = () => {
  const { defiData } = useHashConnect();
  const data: DefiDataValues = getDefiData(defiData);
  const hbarIcon = useColorModeValue(hbarLightIcon, hbarDarkIcon);
  const hbarxIcon = useColorModeValue(hbarxLightIcon, hbarxDarkIcon);
  const itemGroups = getItemGroups({
    hbarIcon: hbarIcon,
    hbarxIcon: hbarxIcon,
    data,
  });

  return (
    <>
      <HeadPage
        title="Hedera Staking - Liquid Staking With Hbar Simplified|Stader Labs"
        keywords="hedera staking, hedera crypto, hbarcrypto"
        url="https://www.staderlabs.com/hedera/"
        description="Liquid staking with Stader. Stake HBAR with Stader to earn rewards while keeping full control of your staked tokens. Start earning rewards in just a few clicks."
      />
      <Subtitle
        title="DeFi"
        description="Use HBARX and explore additional yield while still earning your
        staking rewards"
        logo={hbarIcon}
      />
      <Box p={{ base: 0, lg: "1rem" }} pt="0">
        {!_isEmpty(defiData) ? (
          <Flex my="12" gap="8" direction="column">
            {itemGroups.map((group) => (
              <Box key={group.title}>
                <Heading size="sm" color="brand.textInactive">
                  {group.title}
                </Heading>
                <Flex
                  gap="1rem"
                  mt="4"
                  flexDir="column"
                  bg="brand.textWhite"
                  _dark={{
                    bg: "brand.textBg",
                  }}
                  p="32px 40px"
                  borderRadius="24px"
                >
                  {group.items.map((item) => {
                    if (
                      !item ||
                      data[item.id]?.tvl === "0" ||
                      data[item.id]?.apy === "0"
                    ) {
                      return null;
                    }
                    return (
                      <Item
                        key={item.id}
                        TVL={data[item.id]?.tvl}
                        APY={data[item.id]?.apy}
                        {...item}
                      />
                    );
                  })}
                </Flex>
              </Box>
            ))}
            <Disclaimer />
          </Flex>
        ) : (
          <Flex alignItems="center" justifyContent="center" h="500px">
            <Spinner size="lg" color="brand.primary" />
          </Flex>
        )}
      </Box>
    </>
  );
};

export default DeFi;
